export default __webpack_public_path__ + "static/media/airplane.19b22d18.png";